import React from 'react';
import SimpleButton from '../../common/SimpleButton/SimpleButton';
import AddTenantModal from '../modals/AddTenantModal/AddTenantModal';
import AddAccountModal from '../modals/AddAccountModal/AddAccountModal';
import useChangeModalVisible from '../../../../../hooks/useChangeModalVisible';
import { modalTypes, buttonTypes } from '../../../constants/factoryTypes';

const ModalFactory = ({ type, ...props }) => {
  switch (type) {
    case modalTypes.tenant:
      return <AddTenantModal {...props} />;
    case modalTypes.account:
      return <AddAccountModal {...props} />;
    default:
      return null;
  }
}


const ButtonFactory = ({ type, ...props }) => {
  switch (type) {
    case buttonTypes.simple:
      return (
        <SimpleButton
          text={props.text}
          textColor={props.textColor}
          onClick={props.onClick}
          className={props.className}
          disabled={props.disabled || false}
        />
      );
    default:
      return null;
  }
};

const ActionWithModalFactory = ({
  actionType,
  modalType,
  actionText,
  actionClassName,
  actionTextColor = 'black',
  actionDisabled,
  modalProps,
}) => {
  const { visible, showModal, hideModal } = useChangeModalVisible();

  return (
    <>
      <ButtonFactory
        type={actionType}
        text={actionText}
        textColor={actionTextColor}
        onClick={showModal}
        className={actionClassName}
        disabled={actionDisabled}
      />
      <ModalFactory
        {...modalProps}
        type={modalType}
        visible={visible}
        onCancel={hideModal}
      />
    </>
  );
};

export default ActionWithModalFactory;
